export enum SubscriptionChangeActions {
  CHANGE = 'change',
  PAUSE = 'pause',
  CANCEL = 'cancel',
  UPDATE = 'update',
  REACTIVATE  = 'reactivate',
  Downgrade = 'downgrade',
  Upgrade = 'upgrade',
}
